import React, { useEffect, useState } from 'react';
import defaultAvatar from '../assets/img/profile-placeholder.svg';

/**
 * Renders an <img> that falls back to a placeholder when src is empty or fails to load.
 */
export default function ImageWithFallback({
  src,
  alt = 'img',
  fallbackSrc = defaultAvatar,
  onError,
  ...props
}) {
  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);

  useEffect(() => {
    setImgSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError = (e) => {
    if (typeof onError === 'function') onError(e);
    // Avoid infinite loop if fallback also fails
    if (imgSrc !== fallbackSrc) setImgSrc(fallbackSrc);
  };

  return <img src={imgSrc || fallbackSrc} alt={alt} onError={handleError} {...props} />;
}

